import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  reduxForm, Field, change, getFormValues,
} from 'redux-form';
import { t } from 'i18next';
import Modal from 'react-modal';
import Row from '../ReactComponent/Row';
import Column from '../ReactComponent/Column';
import { isRequired } from '../../utils/validator';
import FieldFileInput from '../ReactComponent/FileUploadButton';
import { putReduxAllCompanies } from '../ManageCompanies/actions';
import { getCompaniesList, postImportContacts } from '../../services/companies';
import ImportModal from './ImportModal';
import { getCompanyContacts } from '../../services/contacts';
import {
  DownloadFileNames,
  downloadReport,
  formatContactReports,
  downloadContactImportTemplate,
} from '../../utils/reports';
import { ImportContactTypes, Locales } from '../../utils/enums';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import {
  Close, ModalBody, ModalTitle, ButtonDiv,
} from '../ManagePickups/css';
import {
  PageTitle,
  PageDescription,
  ContactsContainer,
  TemplateRuleList,
  ModalContent,
  ContentBoxLightGrey,
  FileUpload,
  InstructionLink,
  ImportExportContainer,
  RadioFieldContainer,
  RadioField,
  FieldLabel,
  SelectContact,
} from './css';
import { P, H2, H3 } from '../../theme/typography';
import Dropdown from '../../lib/ui/form_elements/Dropdown';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import RadioButton from '../../lib/ui/form_elements/RadioButton';
import Tooltip from '../../lib/ui/form_elements/Tooltip';

const formName = 'ImportExportForm';
let locale;

class ImportExportForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      ddlCompanyNames: [],
      companiesList: [],
      errorList: [],
      openImportModal: false,
      companyId: '',
      contactTypesToImport: '',
      contactTypesToExport: '',
      disabledExportButton: true,
      noFileforDownload: false,
      modalIsOpen: false,
    };
  }

  componentDidMount() {
    setTimeout(() => { this.fetchCompaniesAssociatedToUser(); }, 200);

    this.fetchCompaniesAssociatedToUser();
  }

  fetchCompaniesAssociatedToUser = async () => {
    const { division, userId, putReduxAllCompanies } = this.props;
    const { data: companies } = await getCompaniesList(division, userId);
    if (companies) {
      putReduxAllCompanies(companies);
      const companyNames = companies.map((company) => company.companyName);
      this.setState({ ddlCompanyNames: companyNames, companiesList: companies });
    }
  };

  handleCompanySelect = (event, newValue) => {
    const { dispatch } = this.props;
    const { companiesList } = this.state;
    if (companiesList) {
      const companyIdValue = companiesList.filter(
        (eachCompany) => eachCompany.companyName === newValue)[0].companyId;
      this.setState({ companyId: companyIdValue });
    }

    dispatch(change(formName, 'exportContractType', 'All'));
  };

  onImportChangeContractType = (e) => { this.setState({ contactTypesToImport: e.target.value, errorList: [] }); };

  onExportChangeContractType = (e) => {
    this.setState({
      contactTypesToExport:
    e.target.value,
      disabledExportButton: false,
      noFileforDownload: false,
    });
  };

  handleDownloadSubmit = async () => {
    const { companyId, contactTypesToExport } = this.state;
    this.setState({ errorList: [] });
    await getCompanyContacts(companyId, contactTypesToExport).then((res) => {
      if (res.status === 200) {
        const filterValue = contactTypesToExport !== 'All'
          && contactTypesToExport.split(' (')[0];
        const responseData = contactTypesToExport !== 'All' ? res.data.filter((eachItem) => eachItem.contactType === filterValue) : res.data;
        if (responseData.length > 0) {
          downloadReport(DownloadFileNames.ContactsReport, formatContactReports, responseData);
        } else {
          this.setState({ noFileforDownload: true, errorList: [] });
          this.importModalBox(true);
        }
      }
    });
    this.reset();
  };

  cleanCsvBase64 = (base64String) => {
    // Strip UTF-8 BOM if present
    let decoded = atob(base64String);
    if (decoded.startsWith('\xEF\xBB\xBF')) {
      decoded = decoded.slice(3);
    }

    const lines = decoded.split(/\r?\n/);
    const cleanedLines = lines.map((line) => {
      const trimmed = line.trim();
      if (!trimmed) return '';
      // Fix lines from Excel where the entire row is wrapped in quotes
      const match = trimmed.match(/^"(.*)"[;]*$/);
      if (match) {
        const inner = match[1];
        if (inner.split(';').length === 13) {
          return inner;
        }
      }

      return trimmed;
    });

    // Detect delimiter: if header has 13 semicolon-separated fields, convert to commas
    const header = cleanedLines.find((l) => l.trim() !== '');
    if (header && header.split(';').length === 13) {
      // File uses semicolons as delimiter - convert to commas for the backend
      const convertedLines = cleanedLines.map((line) => {
        if (!line) return '';
        const fields = line.split(';');
        // Quote fields that contain commas
        const quotedFields = fields.map((field) => (
          field.includes(',') ? `"${field}"` : field
        ));

        return quotedFields.join(',');
      });

      return btoa(convertedLines.join('\r\n'));
    }

    return btoa(cleanedLines.join('\r\n'));
  };

  validateCsvContent = (base64String) => {
    // Validates the RAW file (before delimiter conversion)
    // by checking with semicolons as delimiter
    try {
      let decoded = atob(base64String);
      if (decoded.startsWith('\xEF\xBB\xBF')) {
        decoded = decoded.slice(3);
      }

      const lines = decoded.split(/\r?\n/).filter((line) => line.trim() !== '');
      const expectedFields = 13;
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        // Strip outer quotes if present (Excel pattern)
        const match = line.match(/^"(.*)"[;]*$/);
        const content = (match && match[1].split(';').length === 13)
          ? match[1] : line;
        const fields = content.split(';');
        if (fields.length !== expectedFields) {
          return false;
        }
      }

      return true;
    } catch (e) {
      return false;
    }
  };

  processImportCSVData = () => {
    const { valid, formData } = this.props;

    if (valid) {
      const { companyId, contactTypesToImport } = this.state;

      if (!this.validateCsvContent(formData.importFileUpload.file)) {
        this.setState({
          errorList: [{
            statusCode: 400,
            errors: [{ errorMessage: t('InvalidCSVFormat') }],
          }],
          noFileforDownload: false,
        });
        this.importModalBox(true);

        return;
      }

      const cleanedBase64 = this.cleanCsvBase64(formData.importFileUpload.file);
      const formDatatoAPI = {
        companyId,
        contactTypesToImport,
        csvFileDataAsBase64: cleanedBase64,
      };

      postImportContacts(formDatatoAPI).then((res) => {
        const allErrors = res.data.filter((eachContact) => eachContact.statusCode >= 200 || eachContact.statusCode < 300);
        this.setState({
          errorList: allErrors,
          noFileforDownload: false,
        });
        this.importModalBox(true);
        this.reset();
      }).catch(() => {
        this.openModal();
      });
    }
  };

  renderHeader = ({ heading, description }) => (
    <Row>
      <Column $tablet={12} $mobile={12} style={{ marginBottom: '32px' }}>
        <div>
          <PageTitle>{heading}</PageTitle>
          <PageDescription>{description}</PageDescription>
        </div>
      </Column>
    </Row>
  );

  importModalBox = (isOpen) => {
    this.setState({ openImportModal: isOpen });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    });
  };

  reset() {
    const { dispatch } = this.props;
    dispatch(change(formName, 'importFileUpload', ''));
  }

  render() {
    const {
      rendering: {
        fields: {
          heading, description,
          importContactTypesAll,
          importContactTypesShipper,
          importContactTypesConsignee,
          importContactTypesOther,
          importContactTypesShared,
        },
      },
      valid,
    } = this.props;
    const {
      openImportModal, ddlCompanyNames, errorList, companyId, disabledExportButton, noFileforDownload, modalIsOpen,
    } = this.state;
    if (typeof window !== 'undefined') {
      locale = window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
        ? 'https://dayross.com/fr-CA/Tutorials-Importing-Contacts' : 'https://www.dayross.com/Tutorials-Importing-Contacts';
    }

    return (
      <ImportExportContainer>
        {this.renderHeader({
          heading: heading.value,
          description: description.value,
        })}

        {openImportModal
          && (
          <ImportModal
            isOpen={openImportModal}
            onClose={() => this.importModalBox(false)}
            onSuccess={() => {
              this.closeImportModal(false);
            }}
            errorData={errorList}
            noFile={noFileforDownload}
          />
          )}

        <ContactsContainer>
          <div className="row">
            <Column $desktop={6}>
              <Field
                name="selectedCompany"
                type="dropdown"
                label={t('importlblCompanies')}
                component={Dropdown}
                options={ddlCompanyNames.map((item) => ({ value: item }))}
                onChange={(event, newValue) =>
                  this.handleCompanySelect(event, newValue)}
              />
            </Column>
          </div>
          {companyId
            && (
            <>
              <Row>
                <Column $tablet={12} $mobile={12}>
                  <ContentBoxLightGrey>
                    <ModalContent>
                      <div>
                        <H2>{t('lblImportContacts')}</H2>
                        <H3>{t('lblImportFileTemplate')}</H3>
                        <Row>
                          <Column auto $mobile="auto">
                            <SecondaryButton
                              label={t('btnDownloadTemplate')}
                              isIconLeftPosition={false}
                              onClick={() => { downloadContactImportTemplate(); }}
                            />
                          </Column>
                          <Column $mobile={12} $tablet={6} className="d-flex align-items-center">
                            <InstructionLink>
                              <a
                                href={locale}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="link"
                              >
                                {t('InstructionsforImportingContacts')}
                              </a>
                            </InstructionLink>
                          </Column>
                        </Row>
                        <TemplateRuleList>
                          <li>{t('DownloadTemplateRuleList1')}</li>
                          <li>{t('DownloadTemplateRuleList2')}</li>
                          <li>{t('DownloadTemplateRuleList3')}</li>
                          <li>{t('DownloadTemplateRuleList4')}</li>
                          <li>{t('DownloadTemplateRuleList5')}</li>
                          <li>{t('DownloadTemplateRuleList6')}</li>
                        </TemplateRuleList>
                      </div>
                      <SelectContact>{t('lblSelectTypeToImport')}</SelectContact>
                      <RadioFieldContainer>
                        <FieldLabel>
                          {t('lblContactType')}
                          <Tooltip message={t('TipContactType')} />
                        </FieldLabel>
                        <RadioField>
                          <Field
                            name="importContractType"
                            component={RadioButton}
                            options={[
                              { label: t(importContactTypesAll.value), value: 'ALL' },
                              { label: t(importContactTypesShipper.value), value: 'SHP' },
                              { label: t(importContactTypesConsignee.value), value: 'CON' },
                              { label: t(importContactTypesOther.value), value: 'OTR' },
                              { label: t(importContactTypesShared.value), value: 'SHR' },
                            ]}
                            onChange={(e) => this.onImportChangeContractType(e)}
                            validate={[isRequired]}
                            required
                          />
                        </RadioField>
                      </RadioFieldContainer>
                      <Row>
                        <Column $mobile="auto">
                          <H3>{t('lblSelectFileToUpload')}</H3>
                          <P>
                            {t('lblAcceptedFile')}
                            {' '}
                          </P>
                        </Column>
                        <Column className="d-flex align-items-center">
                          <FileUpload
                            component={FieldFileInput}
                            attachButton="File Upload"
                            name="importFileUpload"
                            className="inline file-upload"
                            validate={[isRequired]}
                          />
                        </Column>
                      </Row>
                      <Row>
                        <Column $desktop={6}>
                          <PrimaryButton
                            className="active"
                            iconRightArrow
                            style={{ margin: '16px 0' }}
                            disabled={!valid}
                            onClick={this.processImportCSVData}
                          >
                            {t('lblImportContacts')}
                          </PrimaryButton>
                        </Column>
                      </Row>
                    </ModalContent>
                  </ContentBoxLightGrey>
                </Column>
              </Row>
              <Row>
                <Column $desktop={12}>
                  <ContentBoxLightGrey>
                    <ModalContent>
                      <H2>{t('lblExportContacts')}</H2>
                      <P>{t('lblExportDesc')}</P>
                      <SelectContact>{t('lblSelectContactTypeExport')}</SelectContact>
                      <RadioFieldContainer>
                        <FieldLabel>
                          {t('lblContactType')}
                          <Tooltip message={t('TipContactType')} />
                        </FieldLabel>
                        <RadioField>
                          <Field
                            name="exportContractType"
                            component={RadioButton}
                            options={[
                              { label: t(importContactTypesAll.value), value: ImportContactTypes.ALL },
                              { label: t(importContactTypesShipper.value), value: ImportContactTypes.SHIPPER },
                              { label: t(importContactTypesConsignee.value), value: ImportContactTypes.CONSIGNEE },
                              { label: t(importContactTypesOther.value), value: ImportContactTypes.OTHER },
                              { label: t(importContactTypesShared.value), value: ImportContactTypes.SHARED },
                            ]}
                            onChange={(e) => this.onExportChangeContractType(e)}
                          />
                        </RadioField>
                      </RadioFieldContainer>
                      <Row>
                        <Column $desktop={6}>
                          <PrimaryButton
                            className="active"
                            iconRightArrow
                            style={{ margin: '16px 0' }}
                            disabled={disabledExportButton}
                            onClick={this.handleDownloadSubmit}
                          >
                            {t('lblExportContacts')}
                          </PrimaryButton>
                        </Column>
                      </Row>
                    </ModalContent>
                  </ContentBoxLightGrey>
                </Column>
              </Row>
            </>
            )}
        </ContactsContainer>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <Close onClick={this.closeModal} />
          <ModalBody className="justify-content-center">
            <ModalTitle>{ t('WarningTitle')}</ModalTitle>
            <p>{t('CSVFileCheckWarning')}</p>
            <ButtonDiv className="row justify-content-center">
              <div className="col-sm-4">
                <SecondaryButton
                  onClick={(e) => this.closeModal(e)}
                  className="active"
                  name="acceptErrorMessage"
                  showArrow={false}
                  style={{ width: '100%' }}
                >
                  {t('Okay')}
                </SecondaryButton>
              </div>
            </ButtonDiv>
          </ModalBody>
        </Modal>
      </ImportExportContainer>
    );
  }
}

ImportExportForm = reduxForm({
  form: formName, // a unique identifier for this form
})(ImportExportForm);

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  division: state.profile.division,
  userId: state.profile.userId,
  selectedCompany:
    state.form.formName
    && state.form.formName.values
    && state.form.formName.values.selectedCompany,
});

const mdtp = (dispatch) => ({
  putReduxAllCompanies: (companies) => dispatch(putReduxAllCompanies(companies)),
});

export default connect(
  mstp,
  mdtp,
)(ImportExportForm);

ImportExportForm.propTypes = {
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.object,
      description: PropTypes.object,
      importContactTypesAll: PropTypes.object,
      importContactTypesShipper: PropTypes.object,
      importContactTypesConsignee: PropTypes.object,
      importContactTypesOther: PropTypes.object,
      importContactTypesShared: PropTypes.object,
    }),
  }),
  valid: PropTypes.bool,
  division: PropTypes.string,
  userId: PropTypes.string,
  putReduxAllCompanies: PropTypes.func,
  dispatch: PropTypes.func,
  formData: PropTypes.object,
};
